import { EnumExportItemList, EnumMasterSort } from './enum';
import { IexportItemList, IquerySort } from './type';

export const initMasterSort: IquerySort[] = [
  {
    [EnumMasterSort.desc]: false,
    [EnumMasterSort.property]: '',
  },
  {
    [EnumMasterSort.desc]: false,
    [EnumMasterSort.property]: '',
  },
  {
    [EnumMasterSort.desc]: false,
    [EnumMasterSort.property]: '',
  },
];

export const initExportItemList: IexportItemList = {
  [EnumExportItemList.rptDefault]: false,
  [EnumExportItemList.flatfileTxt]: false,
  [EnumExportItemList.flatfileCsv]: false,
  [EnumExportItemList.rptReturn]: false,
  [EnumExportItemList.rptReturnNote]: false,
  [EnumExportItemList.previewReturn]: false,
  [EnumExportItemList.previewDefault]: false,
  [EnumExportItemList.previewReturnNote]: false,
  [EnumExportItemList.flatfileProdTxt]: false,
};
